import { CircularProgress, Divider, Modal } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 12px;
  background: var(--color-back-opacity-10);
  border-radius: 5px;
`;

export const CustomModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  .body {
    position: relative;
    background: #fff;
    position: relative;
    background: #fff;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 350px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--color-navy-blue);
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 300px;
  overflow-y: auto;
  padding-right: 4px;
  min-height: 200px;

  .css-26l3qy-menu {
    z-index: 100000;
  }

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  user-select: none;
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
`;

export const CustomCaledar = styled.button`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 8px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: auto;
  height: min-content;
  display: flex;
  gap: 4px;
  align-items: center;
  border-color: var(--color-blue);

  svg {
    color: var(--color-blue);
  }
`;

export const OptionItem = styled.button<{ selected?: boolean }>`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 4px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: min-content;
  height: min-content;

  p {
    font-weight: 600;
  }

  ${(p) =>
    p.selected &&
    css`
      border-color: var(--color-blue);

      p {
        color: var(--color-blue);
      }
    `}
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: var(--color-blue);
`;

export const CustomCouponItem = styled.li<{
  selected?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  cursor: pointer;

  :hover {
    border-color: var(--color-blue-opacity-50);
  }

  h2 {
    color: var(--color-blue-medium-dark);
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    text-align: center;
  }

  p {
    color: var(--color-alba-grandeza);
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    strong {
      font-weight: 700;
      color: var(--color-blue-medium-dark);
    }
  }

  ${(p) =>
    p.selected &&
    css`
      border-color: var(--color-blue);
    `}

  ${(p) =>
    p.disabled &&
    css`
      border-color: var(--color-back-opacity-10) !important;
      cursor: not-allowed;

      h2 {
        color: var(--color-back-opacity-10) !important;
      }

      p {
        color: var(--color-back-opacity-10) !important;

        strong {
          color: var(--color-back-opacity-10) !important;
        }
      }
    `}
`;
